export const SAVE_SERVICE_ITEM_ASSIGN_ACTION = 'SAVE_SERVICE_ITEM_ASSIGN_ACTION'
export const SAVE_SERVICE_ITEM_ASSIGN_SUCCESS = 'SAVE_SERVICE_ITEM_ASSIGN_SUCCESS'

export const GO_BUTTON_SERVICE_ITEM_ASSIGN = 'GO_BUTTON_SERVICE_ITEM_ASSIGN'
export const GO_BUTTON_SERVICE_ITEM_ASSIGN_SUCCESS = 'GO_BUTTON_SERVICE_ITEM_ASSIGN_SUCCESS'

export const SERVICE_ITEM_ASSIGN_API_ERROR_ACTION = 'SERVICE_ITEM_ASSIGN_API_ERROR_ACTION'
